import _ from 'underscore';
import {
    RailwayTourProduct,
    RailwayTariff,
    Station,
    ApiRailwayTour,
} from '@ve/types';

import { ApiRailwayLeg } from '@ve/types/railway/ApiRailwayLeg';
import { ApiRailwayRoute } from '@ve/types/railway/ApiRailwayRoute';
import routesAdapter from './routesAdapter';

type ApiRailwayData = {
    railwayTour: ApiRailwayTour;
    tariffs: RailwayTariff[];
    legs: ApiRailwayLeg[];
    stations: Station[];
    routes: ApiRailwayRoute[];
}

export default (railwayData: ApiRailwayData): RailwayTourProduct => ({
    ..._.pick(railwayData.railwayTour,
        'price',
        'discount',
        'medicalInsurance'),
    type: 'RailwayTourProduct',
    railwayTour: {
        ..._.pick(railwayData.railwayTour,
            'id',
            'nights',
            'checkInDate',
            'meal',
            'departureCity',
            'country',
            'resort',
            'cashbackAvailable',
            'operator',
            'price',
            'room',
            'touristGroup',
            'hotelAvailable',
            'discount',
            'hotel',
            'hotelCategory'),
        originalPrice: railwayData.railwayTour.maxHistoricalPrice,
        routes: routesAdapter(railwayData),
    },
});